import { Box } from "@mui/material";
import { smLogo } from "../../iconsImports"; // Make sure this path is correct

const SmallLoader = ({ loading }) => {
  if (!loading) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        borderRadius: 2,
        zIndex: 1301,
      }}
    >
      <img
        src={smLogo}
        alt="Loading..."
        style={{
          width: 60,
          animation: "floatLogo 2s ease-in-out infinite",
        }}
      />
      <p style={{ marginTop: 16, color: "#fff", fontWeight: 500 }}>
        Loading...
      </p>

      <style jsx>{`
        @keyframes floatLogo {
          0% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
          100% {
            transform: translateY(0);
          }
        }
      `}</style>
    </Box>
  );
};

export default SmallLoader;
